var StateDestinationFactory = function ($q, $http, $window) {
  var factory = {};

  factory.determineNextState = function (flowName) {
    var deferred = $q.defer();

    $http
      .get(
        __authenticationUrl__ +
        "rest/partialauth/state/getNextUserState/" +
        flowName
      )
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        // TODO: Use logger to log the error message

        deferred.reject(data);
      });

    return deferred.promise;
  };

  factory.getParticipantDataAsync = function () {
    var deferred = $q.defer();
    $http
      .get(
        __authenticationUrl__ +
        "rest/partialauth/retirementIncomeView/participantLoginInformation"
      )
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        // TODO: Use logger to log the error message

        deferred.reject(data);
      });
    return deferred.promise;
  };

  factory.determineNextDest = function (flowName) {
    var deferred = $q.defer();

    $http
      .get(
        __baseApiUrl__ +
        "/participant-web-services/rest/partialauth/dest/getNextAuthDestination/" +
        flowName
      )
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        // TODO: Use logger to log the error message

        deferred.reject(data);
      });

    return deferred.promise;
  };

  factory.getInBoundUser = function () {
    var deferred = $q.defer();

    $http
      .get(__authenticationUrl__ + "rest/nonauth/getInBoundUser")
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        // TODO: Use logger to log the error message

        deferred.reject(data);
      });

    return deferred.promise;
  };

  return factory;
};

StateDestinationFactory.$inject = ["$q", "$http", "$window"];
export default StateDestinationFactory;
